import React, { useReducer } from "react";
import UserContext from "./userContext";

import userReducer from "./userReducer";
import { appFirestore } from "../../firebase/config";
import {
  GET_USER,
  GET_USERVIDEOS,
  GET_NOTES,
  GET_BOOKMARKS,
  FILTER_VIDEOS,
  CLEAR_USER,
  CLEAR_FILTER,
} from "../types";

const UserState = (props) => {
  const initialState = {
    user: null,
    loading: true,
    filter: null,
    videos: null,
    notes: null,
  };
  const [state, dispatch] = useReducer(userReducer, initialState);

  //-------------------------------------------------------------------------------------------------------------

  const getUser = async (id) => {
    try {
      const res = await appFirestore.collection("users").doc(id).get();
      dispatch({ type: GET_USER, payload: res.data() });
    } catch (error) {
      console.log(error.message);
    }
  };

  //---------------------------------------------------------------------------------------------------------------
  const getUserResources = async ({ type, id }) => {
    try {
      const res = await appFirestore
        .collection("academics")
        .where("owner", "==", id)
        .get();
      let allVids = [];
      let allNotes = [];

      //loop through query result and put each item in an object in array

      res.forEach((doc) => {
        if (doc.data().type === "videos") {
          allVids.push({
            ...doc.data(),
            coll: "acad",
            id: doc.id,
          });
        } else {
          allNotes.push({
            ...doc.data(),
            coll: "acad",
            id: doc.id,
          });
        }
      });
      const res2 = await appFirestore
        .collection("extracurriculars")
        .where("owner", "==", id)
        .get();

      //loop through query result and put each item in an object in array

      res2.forEach((doc) => {
        if (doc.data().type === "videos") {
          allVids.push({
            ...doc.data(),
            coll: "extra",
            id: doc.id,
          });
        } else {
          allNotes.push({
            ...doc.data(),
            coll: "extra",
            id: doc.id,
          });
        }
      });

      //loop through query result and put each item in an object in array

      dispatch({ type: GET_USERVIDEOS, payload: allVids });

      dispatch({ type: GET_NOTES, payload: allNotes });
    } catch (error) {
      console.log(error.message);
    }
  };

  //--------------------------------------------------------------------------------------------------------------
  const filterVideos = (text, type) => {
    dispatch({ type: FILTER_VIDEOS, payload: { text, type } });
  };

  const clearFilter = () => {
    dispatch({ type: CLEAR_FILTER });
  };

  const clearUser = () => {
    dispatch({ type: CLEAR_USER });
  };
  return (
    <UserContext.Provider
      value={{
        user: state.user,
        notes: state.notes,
        loading: state.loading,
        videos: state.videos,
        filter: state.filter,
        getUser,
        getUserResources,
        filterVideos,
        clearUser,
        clearFilter,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
